import React, {ReactNode} from "react";

import SupportEmail from "@components/SupportEmail";

export default function formatError({
  status,
  message,
  detail,
}: {
  status?: number;
  message?: string;
  detail?: string;
}): ReactNode {
  if (status === 403) {
    return detail;
  }

  return (
    message || (
      <>
        Sorry, there was an error loading this menu. Please refresh the page and
        try again. If the problem persists, please contact support at{" "}
        <SupportEmail />
      </>
    )
  );
}
